module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v(_vm._s(_vm.label))]), _vm._l((_vm.options), function(option) {
    return _c('dd', {
      ref: "dd",
      refInFor: true
    }, [_c('label', {
      ref: "cbox_label",
      refInFor: true,
      staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
      attrs: {
        "for": 'id_' + option.value
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.option_values),
        expression: "option_values"
      }],
      staticClass: "mdl-checkbox__input",
      attrs: {
        "id": 'id_' + option.value,
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.option_values) ? _vm._i(_vm.option_values, option.value) > -1 : (_vm.option_values)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.option_values,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.option_values = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.option_values = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.option_values = $$c
          }
        }, _vm.onChange]
      }
    }), _c('span', {
      staticClass: "mdl-checkbox__label",
      domProps: {
        "innerHTML": _vm._s(option.value)
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12d106fb","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/form/MultiCheckbox.vue
// module id = 505
// module chunks = 1